module.exports = __webpack_public_path__ + "static/img/2.774aa0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/dhw/2.jpg
// module id = 1i6t
// module chunks = 1